export const DISPLAY_PAYMENT_OPTIONS_MAP = {
  'CARD': 'Card',
  'APPLE': 'Apple Pay',
  'GOOGLE': 'Google Pay',
  'QIWI': 'Qiwi',
  'YOOMONEY': 'YooMoney',
  'PAYME': 'PayMe',
  'YANDEX': 'Yandex Pay',
};

export const EXTERNAL_PAYMENT_OPTIONS = [
  'QIWI',
  'YOOMONEY',
  'CRYPTO',
];

export const SPECIAL_PAYMENT_OPTIONS = [
  'APPLE',
  'GOOGLE',
  'YANDEX',
];

// TODO: CPME-4044 Данный список будет неактуален после выполнения задачи на бэкенде
export const RUB_PAYMENT_OPTIONS = [
  'APPLE',
  'GOOGLE',
  'QIWI',
  'YOOMONEY',
];

// TODO: CPME-4044 Данный список будет неактуален после выполнения задачи на бэкенде
export const UZS_PAYMENT_OPTIONS = [
  'PAYME',
];
